export type PersonsChangedReason = "created" | "updated" | "deleted" | "other";

export type PersonsChangedDetail = {
  reason?: PersonsChangedReason;
  personId?: string;
};

const PERSONS_CHANGED_EVENT = "m1member:personsChanged";
const PERSONS_CHANGED_AT_KEY = "m1member:personsChangedAt";

export function emitPersonsChanged(detail?: PersonsChangedDetail) {
  try {
    localStorage.setItem(PERSONS_CHANGED_AT_KEY, String(Date.now()));
  } catch {
    // ignore (private mode / blocked storage)
  }
  window.dispatchEvent(new CustomEvent<PersonsChangedDetail>(PERSONS_CHANGED_EVENT, { detail }));
}

export function getPersonsChangedAt(): number {
  try {
    const v = localStorage.getItem(PERSONS_CHANGED_AT_KEY);
    const n = v ? Number(v) : 0;
    return Number.isFinite(n) ? n : 0;
  } catch {
    return 0;
  }
}

export function onPersonsChanged(handler: (detail: PersonsChangedDetail) => void) {
  const wrapped = (ev: Event) => {
    const ce = ev as CustomEvent<PersonsChangedDetail>;
    handler(ce.detail ?? {});
  };
  window.addEventListener(PERSONS_CHANGED_EVENT, wrapped);

  // Cross-tab updates (and also helps when CustomEvent isn't observed in a given view)
  const onStorage = (ev: StorageEvent) => {
    if (ev.key === PERSONS_CHANGED_AT_KEY) handler({ reason: "other" });
  };
  window.addEventListener("storage", onStorage);

  return () => {
    window.removeEventListener(PERSONS_CHANGED_EVENT, wrapped);
    window.removeEventListener("storage", onStorage);
  };
}


